import config from '@config';

import createDataSource from '../createDataSource';
import { getDefaultListHandler, getDefaultEmptyList } from '../utils';

const BASE_PATHNAME = 'users';
const EVENTS_PATHNAME = 'events';

export default () => {
  const dataSource = createDataSource(config.api.url);

  const update = ({ id, values }) => dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, id } }).json();
  const getMe = async () => {
    const userMe = await dataSource.get(`${BASE_PATHNAME}/current`).json();
    if (!userMe.eventId) return userMe;

    const event = await dataSource.get(`${EVENTS_PATHNAME}/${userMe.eventId}`).json();
    return { ...userMe, event };
  };

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
    }),

    getEmptyList: getDefaultEmptyList,

    update,
    getMe,
  };
};
